import type { Contracts } from 'prove-common'

export function validPlanContracts(
  contracts: Contracts | undefined,
  labId: number | undefined,
  effectiveDue: string | null | undefined
): Contracts | undefined {
  if (!labId) return contracts
  return contracts?.filter((contract) => {
    if (contract.labId !== labId) return false
    if (!effectiveDue) return true
    const due = new Date(effectiveDue)
    const start = contract.startDate ? new Date(contract.startDate) : undefined
    const end = contract.endDate ? new Date(contract.endDate) : undefined
    if (start && start > due) return false
    if (end && end < due) return false
    return true
  })
}
